import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';
import { Product } from 'shared/types/product';
import { ProductCardProduct } from 'shared/types/product/Product';
import { ProductPaginatedResult } from 'shared/types/result';
import { RouteHelpers } from 'helpers/routerHelpers';
import { matchVariantByColor } from 'helpers/utils/product/variants';
import ProductRecommendationGrid from './ProductRecommendationGrid';

interface Props {
  shopCollectionUrl: string;
  shopCollectionProducts: ProductPaginatedResult;
  product: Product;
}

export default function ProductShopCollection({ shopCollectionProducts, product }: Props) {
  const search = useSearchParams();
  const selectedColor = RouteHelpers.slugify(search.get('color') || '');

  const colorMatcher = useCallback(
    (shopCollectionProduct: ProductCardProduct) => {
      // Get current variant selected based on color search param or default master variant
      const selectedVariant = selectedColor
        ? product.variants.find(
            (variant) => RouteHelpers.slugify(variant?.attributes?.actualColor || '') === selectedColor,
          )
        : product.masterVariant;

      return matchVariantByColor(selectedVariant, shopCollectionProduct);
    },
    [product, selectedColor],
  );

  if (!shopCollectionProducts?.items || shopCollectionProducts?.items?.length < 1) return null;

  const pageTitle = `Shop ${product.collection} Collection`;

  return (
    <ProductRecommendationGrid
      title={pageTitle}
      products={shopCollectionProducts.items}
      location="Shop Collection"
      colorMatcher={colorMatcher}
      maxItems={4}
      sectionId="shop-collection"
      isShopCollection
      collapsable
    />
  );
}
